document.addEventListener('DOMContentLoaded', function () {
   // enable tooltips
   document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (element) {
      new bootstrap.Tooltip(element, {
         boundary: document.body,
         html: true
      });
   });

   // enable system to show join tma modal on items that have the correct class
   document.querySelectorAll('.tma-moto-mod-modal-trigger').forEach(function (button) {
      button.addEventListener('click', function(){
         const moto_mods = JSON.parse(document.getElementById('tma_moto_mods').value);
         const mod_id = this.getAttribute('data-modal-mod-id');
         const mod_data = moto_mods[mod_id];

         if(mod_data){
            tma_moto_mod_modal_populate(mod_data);
            const tma_moto_mod_modal_instance = new bootstrap.Modal(document.getElementById('tma_moto_mod_modal'), {});
            tma_moto_mod_modal_instance.show();
         }
      });
   });

   // copy url
   if(document.querySelector('[data-copy-url]')){
      document.querySelector('[data-copy-url]').addEventListener('click', function(e) {
         e.preventDefault();

         let url = window.location.href;
         let referral = Cookies.get('referral');

         if (referral) {
            url += '?referral=' + encodeURIComponent(referral);
         }

         navigator.clipboard.writeText(url).then(function(){
            let toastElement = new bootstrap.Toast(document.getElementById('copied-url-toast'));
            toastElement.show();
         });
      });
   }

   tma_get_browser_analytics('login_analytics');

   document.querySelectorAll('[data-choose_access_code]').forEach(function (link) {
      link.addEventListener('click', function (event) {
         event.preventDefault();
         document.getElementById('join_access_code').value = link.getAttribute('data-code');
         bootstrap.Modal.getInstance(document.getElementById('tma_access_code_modal')).hide();
      });
   });

   if (fsLightboxInstances && typeof fsLightboxInstances === 'object') {
      Object.values(fsLightboxInstances).forEach(function(instance) {
          fslightboxAddDownloadButton(instance);
      });
   }
});

function tma_paragraph_wrapper(content){
   const lines = content.split('\n');
   return lines.map(line => `<p>${line}</p>`).join('');
}

const tma_moto_mod_modal_fields = [
   {key: 'name', id: 'tma_moto_mod_modal_name'},
   {key: 'rating', id: 'tma_moto_mod_modal_rating', custom_handler: tma_moto_mod_modal_happiness_rating_icon},
   {key: 'description', id: 'tma_moto_mod_modal_description', wrap_with_paragraph: true},
   {key: 'rating_comments', id: 'tma_moto_mod_modal_rating_comments', wrap_with_paragraph: true},
   //{key: 'images', id: 'tma_moto_mod_modal_images', custom_handler: tma_moto_mod_modal_generate_image_html}
];

function tma_moto_mod_modal_populate(mod_data){
   tma_moto_mod_modal_fields.forEach(field => {
      const element = document.getElementById(field.id);
      let value = mod_data[field.key];
      if(field.custom_handler){
         if(field.key === 'images'){
            value = field.custom_handler(value, mod_data.id, mod_data.name);
         }else{
            value = field.custom_handler(value);
         }
      }
      if(field.key === 'name'){
         element.innerHTML = value;
      }else if(field.wrap_with_paragraph){
         value ? tma_moto_mod_modal_show_element_with_content(element, tma_paragraph_wrapper(value)) : tma_moto_mod_modal_hide_element(element);
      }else{
         value ? tma_moto_mod_modal_show_element_with_content(element, value) : tma_moto_mod_modal_hide_element(element);
      }
   });
   refreshFsLightbox();
}

function tma_moto_mod_modal_generate_image_html(images, mod_id, mod_name){
   if(images.length > 0){
      const columns = images.length > 1 ? 2 : 1;
      let image_html = `<div class="row g-3 row-cols-${columns}">`;
      images.forEach(image => {
         image_html += `<div class="col"><a href="https://api.thatmotoapp.com/1/download/${image.upload_id}" data-fslightbox="${mod_id}" data-type="image"><img src="https://api.thatmotoapp.com/1/download/${image.upload_id}" class="img-thumbnail tma-image-thumbnail" alt="${mod_name}"></a></div>`;
      });
      return image_html + `</div>`;
   }
   return '';
}

function tma_moto_mod_modal_show_element_with_content(element, content){
   element.parentNode.style.display = 'block';
   element.innerHTML = content;
}

function tma_moto_mod_modal_hide_element(element){
   element.parentNode.style.display = 'none';
   element.innerHTML = '';
}

function tma_moto_mod_modal_happiness_rating_icon(rating) {
   const ratings = [
      {threshold: 6, icon: "fa-grin-stars", color: "#FF72C4"},
      {threshold: 5, icon: "fa-grin-hearts", color: "#F3BB2C"},
      {threshold: 4, icon: "fa-grin-beam", color: "#00B050"},
      {threshold: 3, icon: "fa-smile", color: "#92D050"},
      {threshold: 2, icon: "fa-meh", color: "#FFFFFF"},
      {threshold: 1, icon: "fa-frown", color: "#00B0F0"},
      {threshold: -Infinity, icon: "fa-ban", color: "#999999"}
   ];

   for(const data of ratings){
      if(rating >= data.threshold){
         return `<i class="fas fa-fw fa-3x ${data.icon}" style="color:${data.color}"></i>`;
      }
   }
}

function tma_form_submit(button, form) {
   if (button.getAttribute('name') === 'action' && button.getAttribute('value') === 'Cancel') {
      window.location.reload();
   }
   form = document.querySelector(form);
   if (!form) {
      form = button.closest('form');
   }
   let submitButton = form.querySelector('input[type="submit"][name="' + button.getAttribute('name') + '"]');
   if (!submitButton) {
      let submitButton = document.createElement("input");
      submitButton.setAttribute("type", "submit");
      submitButton.setAttribute("name", button.getAttribute('name'));
      submitButton.setAttribute("value", button.getAttribute('value'));
      submitButton.style.display = 'none';
      form.appendChild(submitButton);
      form.dataset.submitting = 'true';
      submitButton.click();
   }
   let valid = form.checkValidity();
   if (valid) {
      button.innerHTML = '<i data-icon="spinner" class="icon fa fa-spinner fa-spin"></i>';
      button.classList.add('submitting');
      button.disabled = true;
      form.querySelector('input[type="submit"][name="' + button.getAttribute('name') + '"]').click();
   }
}

function tma_form_visibility_swap(link, form_1, form_2) {
   event.preventDefault();

   if (link.closest('form').id === form_1) {
      document.getElementById(form_1).style.display = 'none';
      document.getElementById(form_2).style.display = 'block';
   } else if (link.closest('form').id === form_2) {
      document.getElementById(form_1).style.display = 'block';
      document.getElementById(form_2).style.display = 'none';
   }
}

function tma_motos_apply_classification_filter(trigger, classification) {
   document.getElementById('tma_motos_filter_classification').value = classification;
   tma_motos_submit_filter();
}

function tma_motos_submit_filter() {
   const filterElements = {
      classification: document.getElementById('tma_motos_filter_classification'),
      country: document.getElementById('tma_motos_filter_country'),
      region: document.getElementById('tma_motos_filter_region')
   };

   window.location.href = '/motos/1?' + Object.keys(filterElements)
      .filter(key => filterElements[key] && filterElements[key].value.trim() !== '')
      .map(key => `filter[${key}]=${filterElements[key].value}`)
      .join('&');
}

function tma_events_apply_apply_filter(target_id, filter){
   document.getElementById(target_id).value = filter;
   tma_events_submit_filter();
}

function tma_events_submit_filter() {
   const filterElements = {
      classification: document.getElementById('tma_events_filter_classification'),
      type: document.getElementById('tma_events_filter_type'),
      country: document.getElementById('tma_events_filter_country'),
      pricing: document.getElementById('tma_events_filter_pricing'),
   };

   window.location.href = '/events/1?' + Object.keys(filterElements)
      .filter(key => filterElements[key] && filterElements[key].value.trim() !== '')
      .map(key => `filter[${key}]=${filterElements[key].value}`)
      .join('&');
}

function tma_get_browser_analytics(target_id) {
   // Check if ua-parser-js library is available and target field exists
   if (typeof UAParser !== 'undefined' && document.getElementById(target_id)) {
      // Create a new instance of UAParser
      var parser = new UAParser();
      var result = parser.getResult();

      // Create the JSON object
      var analytics_json = {
         device: {
            type: result.device.type,
            model: result.device.model,
            vendor: result.device.vendor
         },
         os: {
            name: result.os.name,
            version: result.os.version
         },
         browser: {
            name: result.browser.name,
            version: result.browser.version
         },
         resolution: {
            height: window.innerHeight,
            width: window.innerWidth
         }
      };

      // Convert the JSON object to a string
      var analytics_json_string = JSON.stringify(analytics_json);

      // Set the value of the target form field
      document.getElementById(target_id).value = analytics_json_string;
   }
}


document.addEventListener("DOMContentLoaded", function () {
   let consent = getCookie("analyticsConsent");
   if (consent === "") {
      document.getElementById("cookieConsentBanner").classList.remove("d-none");
   } else if (consent === "yes") {
      loadGoogleAnalytics();
   }

   document.getElementById("acceptCookies").addEventListener("click", function () {
      setCookie("analyticsConsent", "yes", 365);
      document.getElementById("cookieConsentBanner").classList.add("d-none");
      loadGoogleAnalytics();
   });

   document.getElementById("denyCookies").addEventListener("click", function () {
      setCookie("analyticsConsent", "no", 365);
      document.getElementById("cookieConsentBanner").classList.add("d-none");
   });
});

function setCookie(name, value, days) {
   const d = new Date();
   d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
   let expires = "expires=" + d.toUTCString();
   document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(name) {
   let ca = document.cookie.split(';');
   let nameEQ = name + "=";
   for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
   }
   return "";
}

function loadGoogleAnalytics() {
   window.dataLayer = window.dataLayer || [];
   function gtag() { dataLayer.push(arguments); }
   gtag('js', new Date());
   gtag('config', 'G-KY8G95P477'); // Replace with your Google Analytics Measurement ID

   let script = document.createElement('script');
   script.src = `https://www.googletagmanager.com/gtag/js?id=G-KY8G95P477`; // Replace with your Google Analytics Measurement ID
   script.async = true;
   document.head.appendChild(script);
}


/**
 * Add Download Button to fsLightbox
 * This function adds a download button to the fsLightbox instance.
*/
function fslightboxAddDownloadButton(instance) {
   instance.props.onOpen = function () {
       const toolbar = document.querySelector('.fslightbox-toolbar');
       if (toolbar && !toolbar.querySelector('.fslightbox-download-button')) {
           const downloadButton = document.createElement('button');
           downloadButton.className = 'fslightbox-toolbar-button fslightbox-flex-centered fslightbox-download-button bg-transparent border-0';
           downloadButton.innerHTML = `
               <svg width="16px" height="16px" viewBox="0 0 512 512">
                   <path class="fslightbox-svg-path" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
               </svg>
           `;
           downloadButton.addEventListener('click', function () {
               const currentIndex = instance.stageIndexes.current; // Get the current slide index
               const imageSrc = instance.props.sources[currentIndex]; // Get the URL from the sources array

               if (imageSrc) {
                   // Fetch the image and create a Blob for it
                   fetch(imageSrc)
                       .then(response => response.blob())
                       .then(blob => {
                           const url = window.URL.createObjectURL(blob);
                           const a = document.createElement('a');
                           a.href = url;
                           a.download = imageSrc.split('/').pop();
                           document.body.appendChild(a);
                           a.click();
                           window.URL.revokeObjectURL(url);
                           a.remove();
                       })
                       .catch(() => console.error('Failed to download image.'));
               }
           });

           const fullscreenButton = toolbar.querySelector('.fslightbox-toolbar-button[title="Enter fullscreen"]');
           if (fullscreenButton) {
               toolbar.insertBefore(downloadButton, fullscreenButton);
           } else {
               toolbar.appendChild(downloadButton);
           }
       }
   };
}
